import React from 'react';
import { Link } from 'react-router-dom';
import {flatDeep, slugify, containsObject} from '../../../utils';
import BlogData from "../../../data/blog/BlogData.json";


const WidgetCategory = ({activeCategory}) => {

    const activeSlug = activeCategory ? slugify(activeCategory) : null;

    const cats = BlogData.map(data => {
        return data.category;
    });


    let singleCatArray = flatDeep(cats);
    let categories = [];
    singleCatArray.forEach(cat => {
        const obj = {
            title: cat.trim(),
            slug: slugify(cat),
            count: 1
        }
        const objIndex = containsObject(obj, categories);
        if(objIndex !== -1){
            const prevCount = categories[objIndex].count;
            categories[objIndex] = {
                title: cat.trim(),
                slug: slugify(cat),
                count: prevCount + 1
            }
        } else {
            categories.push(obj);
        }
    })

    const excludedSlugs = [
        "information-technology",
        "agency-news",
        "graphic-design",
        "graphics-design",
        "mvp-development",
        "mvp",
        "staff-augmentation",
        "staff",
        "cloud-technology",
        "cloud",
        "cybersecurity",
        "ecommerce"
    ];

    const filteredCategories = categories.filter(cat => !excludedSlugs.includes(cat.slug));

    return (
        <ul className="category-list list-unstyled">
            {filteredCategories.map((data) =>(
                <li key={data.slug} className={data.slug === activeSlug ? "active" : ""}>
                    <Link to={process.env.PUBLIC_URL + `/category/${data.slug}`}>{data.title}</Link>
                </li>
            ))}
        </ul>
    )
}

export default WidgetCategory;